<template>
  <form @submit.prevent="submitForm()" novalidate>
    <p>Для смены пароля введите старый пароль</p>
    <div class="my-1">
      <div class="input-group">
        <div class="input-group-text"><font-awesome-icon icon="fa-solid fa-user" /></div>
        <input
          type="password"
          class="form-control"
          placeholder="старый пароль"
          name="old_password"
          v-model="form.old_password" />
      </div>
      <div data-error class="alert alert-danger my-1 px-2 py-1" role="alert">{{ errors.form.old_password }}</div>
    </div>

    <p class="mt-3">Придумайте новый пароль</p>

    <div class="my-1">
      <div class="input-group">
        <div class="input-group-text"><font-awesome-icon icon="fa-solid fa-user" /></div>
        <input
          type="password"
          class="form-control"
          placeholder="новый пароль"
          name="password"
          v-model="form.password" />
      </div>
      <div data-error class="alert alert-danger my-1 px-2 py-1" role="alert">{{ errors.form.password }}</div>
    </div>

    <div class="my-1">
      <div class="input-group">
        <div class="input-group-text"><font-awesome-icon icon="fa-solid fa-user" /></div>
        <input
          type="password"
          class="form-control"
          placeholder="новый пароль ещё раз"
          name="password_confirmation"
          v-model="form.password_confirmation" />
      </div>
      <div
        v-if="errors.form.password_confirmation.length"
        data-error
        class="alert alert-danger my-1 px-2 py-1"
        role="alert">
        {{ errors.form.password_confirmation }}
      </div>
    </div>

    <div data-error class="alert alert-info mb-1 mt-3 px-2 py-1" role="alert">{{ errors.form.common }}</div>

    <div class="my-1 mt-2">
      <button type="submit" class="btn btn-primary">
        <font-awesome-icon icon="fa-solid fa-check"></font-awesome-icon> Сохранить
      </button>
    </div>
  </form>
</template>

<script>
import axios from 'axios';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faUser, faKey } from '@fortawesome/free-solid-svg-icons';
library.add(faUser, faKey);

export default {
  data: function () {
    return {
      form: {
        _token: this.csrf,
        id: parseInt(this.id),
        fullname: this.fullname,
        chpwd: 1,
        old_password: '',
        password: '',
        password_confirmation: '',
      },
      errors: {
        form: {
          old_password: '',
          password: '',
          password_confirmation: '',
          //
          common: '',
        },
      },
      isLoading: false,
    };
  },
  props: {
    csrf: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    fullname: {
      type: String,
      default: '',
    },
  },
  components: {
    FontAwesomeIcon,
  },
  methods: {
    submitForm() {
      // убрать старые ошибки
      Object.keys(this.errors.form).forEach((key) => {
        this.errors.form[key] = '';
      });

      if (this.form.fullname === '') {
        this.errors.form.common = 'Нужно заполнить имя пользователя в форме слева и сохранить.';
        return false;
      }

      this.isLoading = true;
      this.errors.form.common = 'Сохранение пароля...';

      axios
        .post(`/evocms-user/profile/${this.form.id}`, this.form)
        .then((res) => {
          if (res.data.status === 'ok') {
            this.errors.form.common = 'Успешно сохранено!';

            this.form.old_password = '';
            this.form.password = '';
            this.form.password_confirmation = '';
          }
          if (res.data.status === 'error') {
            const errors = res.data.errors || {};
            const fieldErrors = errors.validation || {};
            const customErrors = errors.customErrors || {};
            const commonErrors = errors.common || [];

            Object.keys(fieldErrors).forEach((key) => {
              this.errors.form[key] = fieldErrors[key].join(' ');
            });

            Object.keys(customErrors).forEach((key) => {
              this.errors.form[key] = customErrors[key].join(' ');
            });

            this.errors.form.common = commonErrors.join(' ');
          }
        })
        .catch((err) => {
          this.errors.form.common = 'Ошибка на сервере, обновите страницу и попробуйте ещё раз.';
          console.error(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
